import type { JSX } from 'react'
import type { IButtonProps } from 'atoms/Button'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { IContainerHeaderProps } from '../ContainerHeader'

import { InlineForwardArrowWithTitle } from 'atoms/Button/Templates'
import { TextBoxMaxLine1Headline3 } from 'atoms/TextBox/Templates'
import { ContainerHeader } from '../ContainerHeader'
import {
  ContainerHeaderAlignItems,
  ContainerHeaderJustifyContent,
} from '../ContainerHeader.h'

export interface IContainerHeaderSpaceBetweenProps extends Omit<
  IContainerHeaderProps,
  'children'
> {
  title?: ITextBoxProps['title']
  controlsTitle?: IButtonProps['title']
}

export const ContainerHeaderSpaceBetween = ({
  title,
  controlsTitle,
  alignItems = ContainerHeaderAlignItems.Baseline,
  justifyContent = ContainerHeaderJustifyContent.SpaceBetween,
  ...rest
}: IContainerHeaderSpaceBetweenProps): JSX.Element => (
  <ContainerHeader
    alignItems={alignItems}
    justifyContent={justifyContent}
    {...rest}
  >
    <TextBoxMaxLine1Headline3 title={title || ''} />
    <InlineForwardArrowWithTitle title={controlsTitle || ''} />
  </ContainerHeader>
)
